module.exports = __webpack_public_path__ + "static/media/life-overview-park-intro0.658aced7.png";